import React, { memo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import HealthPlanMultiSelect from "components/common/HealthPlanMultiSelect";
import ContentModal from "components/ContentModal";
import { ACTIONS } from "./Constants";

// AHCS Health Plan Dialog
export const CreatePolicyDialog = memo(function CreatePolicyDialog({
  open,
  handleClose,
  handleConfirm,
}) {
  const [selectedHealthPlans, setSelectedHealthPlans] = useState([]);
  const isConfirmDisabled = selectedHealthPlans.length === 0;

  const handleCreatePolicyConfirm = () => {
    // Pass selected values to the parent component
    handleConfirm({ action: ACTIONS.CREATE_POLICY, selectedHealthPlans });
  };

  return (
    <ContentModal
      open={open}
      handleClose={handleClose}
      title={
        <Box
          sx={{
            display: "flex",
            fontWeight: "bold",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <span>{`Create Policies for…`}</span>
        </Box>
      }
      content={
        <Box>
          <Typography sx={{ mb: 1 }}>
            Select the Health Plans that are reviewing policies.
          </Typography>
          <HealthPlanMultiSelect
            open={open}
            onChange={setSelectedHealthPlans}
            selectedHealthPlans={selectedHealthPlans}
          />
        </Box>
      }
      actions={
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Button
            onClick={handleCreatePolicyConfirm}
            color="primary"
            disabled={isConfirmDisabled}
          >
            OK
          </Button>
        </Box>
      }
    ></ContentModal>
  );
});
